export default {
    title: 'Filters',
    results: 'Results',
    clean: 'Clean',
    pinAll: 'Pin All',
    cleanAll: 'Clean All',
    search: 'Search Filter ...',
    field: {
        match: 'Match',
        remove: 'Remove',
        operator: 'Filter Type',
        values: 'Value(s)',
        valuePlaceholder: 'Select searching values',
        operatorPlaceholder: 'Select a filter type',
        minValue: 'Min Value',
        maxValue: 'Max Value',
        textPlaceholder: 'Enter a value',
    },
    emptyRelated: {
        title: 'No filters applied',
        text: 'Go to "Filters" section on the left side of the screen to select filters.',
    },
    presets: {
        title: 'My favorite searches',
        placeholder: 'Select a favorite search',
        create: {
            action: 'Save favorite search',
            modal: {
                title: 'Save Favorite Search',
                warning: 'This will create a new favorite search with your current filters (note that all filters will be pinned).',
                name: {
                    label: 'Favorite Search Name',
                    placeholder: 'Enter new favorite search name',
                },
                accept: 'Accept',
                cancel: 'Cancel',
            },
        },
        update: {
            modal: {
                warning: 'This will overwrite the selected favorite search with your current filters (note that all filters will be pinned).',
                placeholder: 'Select a favorite search to update',
            },
        },
        edit: {
            action: 'Edit Name',
            modal: {
                title: 'Edit Preset Name',
                warning: 'This will replace the name of your favorite search "{searchLabel}"',
            },
        },
        delete: {
            action: 'Delete',
            modal: {
                title: 'Delete Favorite Search',
                warning: 'Do you really want to delete the favorite search "{searchLabel}"? This action cannot be undone.',
                accept: 'Delete',
                cancel: 'Cancel',
            },
        },
    },
    restoreUnpinned: {
        title: 'Unpinned Filters',
        description: 'It seems that you have left unpinned filters from the previous step. Do you want to restore them?',
        accept: 'Restore',
        cancel: 'Ignore',
    },
    excluded: 'This related filter has no effect on the entity you are currently in.',
}
